<div class="flex flex-1 mt-2 mb-3" *ngIf="this.context.writePermission">
    <div class="p-input-icon-left flex-1" id="searchBarContainer">
        <i class="ml-1 far fa-magnifying-glass"></i>
        <input type="text" class="w-12" pInputText id="searchBar" (keyup)="onSearchBarKeyUp($event.target)" />
    </div>

    <span class="p-buttonGroup">
        <p-button [dt]="showPushDialog? whiteButtonActive : whiteButton" (click)="showPushDialog=!showPushDialog" icon="far fa-send" class="ml-1 pushnotificationButton"
            *ngIf="currentEventSignUps.length > 0" [class.buttonActive]="showPushDialog" ></p-button>


        <p-button [dt]="whiteButton" class="ml-1 excelButton" (click)="onExportToExcel()" icon="far fa-file-excel"></p-button>

        <p-button [dt]="whiteButton" class="ml-1 qrScannerButton"  (click)="openQRCodeScanner()" icon="far fa-handshake" *ngIf="event.issueTicketsUponRegistration"></p-button>

        <p-button [dt]="viewControl.registrationVisible ? whiteButtonLastActive : whiteButtonLast" class="ml-1 addButton" *ngIf="canWrite" (click)="viewControl.registrationVisible = !viewControl.registrationVisible"
            icon="far fa-plus"></p-button>
    </span>
</div>

<div class="push-notification p-3 mb-3" *ngIf="showPushDialog && currentEventSignUps.length > 0" id="sendPushDialog">
    <div class="font-semibold" i18n="@@event-sign-ups-overview.push-title">Send push message</div>
    <div class="my-2" i18n="@@event-sign-ups-overview.push-placeholder">The message will be sent to all participants in the list.</div>

    <textarea pInputTextarea class="block w-full" [rows]="3" [autoResize]="true" pInputTextarea [maxLength]="2000"
        #pushMessage></textarea>

    <div class="text-right">
        <button pButton type="button" class="mt-2 p-button-secondary sendButton" label="Send message"
            i18n-label="@@event-sign-ups-overview.push.send" (click)="onSendPushNotification(pushMessage)"
            [disabled]="pushMessage.value.length == 0"></button>
    </div>
</div>

<p-panel *ngIf="viewControl.registrationVisible" id="addParticipantDialog">
    <ng-template pTemplate="header">
        <div class="w-full">
            <div class="font-semibold" i18n="@@event-sign-ups-register.component.header">Add participant</div>
        </div>

    </ng-template>
    <form [formGroup]="registrationForm">
        <div class="flex">
            <div class="flex-1 field mb-2 attendeeFirstname">
                <label for="firstname" i18n="@@event-sign-ups-register.component.input.firstName">First name *</label>
                <input pInputText type="text" class="inputfield w-full" formControlName="firstname" autofocus>
            </div>
            <div class="ml-1 flex-1 field mb-2 attendeeName">
                <label for="name" i18n="@@event-sign-ups-register.component.input.name">Name *</label>
                <input pInputText type="text" class="inputfield w-full" formControlName="name">
            </div>
        </div>
        <div class="field mb-2 attendeeEmail">
            <label for="email" i18n="@@event-sign-ups-register.component.input.email">Email</label>

            <input pInputText type="text" class="inputfield w-full" formControlName="email">
        </div>
        <div class="field mb-2 attendeePhone">
            <label for="phone" i18n="@@event-sign-ups-register.component.input.phone">Phone number</label>

            <input pInputText type="text" class="inputfield w-full" formControlName="phoneNumber">
        </div>
        <div class="field mb-1 attendeeComment">
            <label for="comment" i18n="@@event-sign-ups-register.component.input.comment">Comment</label>

            <textarea pInputTextarea id="comment" class="block w-full" rows="3" [autoResize]="true" formControlName="comment">
            </textarea>
        </div>
        <div class="text-right">
            <p-button styleClass="mt-2 p-button-secondary" label="Add participant" [disabled]="!registrationForm.valid"
                i18n-label="@@event-sign-ups-register.component.input.add-participant" class="submitButton"
                (onClick)="onAddParticipant()"></p-button>
        </div>
    </form>
</p-panel>

<div class="w-full signupSort" *ngIf="this.context.writePermission">
    <p-dropdown autoWidth="false" [style]="{'width':'100%'}" [options]="signUpSortingOptions" dataKey="id"
        optionValue="id" [(ngModel)]="activeSorting" optionLabel="label" (onChange)="onApplyFilter()"></p-dropdown>
</div>


<div class="font-semibold mt-2 mb-2 participantNumbers">
    <ng-container *ngIf="viewControl.signups>0">
        <span class="signupNumber">{{viewControl.signups}} <span i18n="@@event-sign-ups-overview.participants">Participants</span></span>
    </ng-container>

    <ng-container *ngIf="viewControl.waitingList>0">
        <span *ngIf="viewControl.signups > 0">,</span>

        <span class="waitinglistNumber">{{viewControl.waitingList}} <span i18n="@@event-sign-ups-overview.wating-list">On waiting list</span></span>
    </ng-container>

</div>

<ng-container *ngIf="currentEventSignUps">
    <div *ngFor="let signUp of currentEventSignUps; let i = index">

        <div class="flex mt-2 align-items-center" id="{{signUp.id}}">
            <div class="flex flex-column flex-1 p-3 md:p-4 w-full eventSignupAttendeeWrapper">
                <div class="flex flex-column justify-content-between md:flex-row">
                    <div class="flex">
                        <div class="flex align-items-center mr-2 md:mr-2">
                            <img *ngIf="currentEventSignUps[i].seat.userProfileId"
                                [src]="apiURL + '/file-api/userprofile/image/' + currentEventSignUps[i].seat.userProfileId + '?thumbnail=true&access_token=' + coreService.getJWTToken()"
                                class="shadow-none w-full profileImage" style="border-radius: 6px; object-fit: cover;max-width:5rem;"
                            />
                        </div>

                        <div class="flex flex-column signupDate" style="word-break: break-all;">
                            <div class="ml-2 md:ml-4" *ngIf="!currentEventSignUps[i].seat.userProfileId"></div>
                            <div class="ml-2 mb-2">
                                {{ signUp.creationDate | date:'medium' }}
                            </div>

                            <div class="ml-2 font-semibold attendeeFullname">
                                {{currentEventSignUps[i].seat.firstname}}
                                {{currentEventSignUps[i].seat.name}}
                            </div>
                            <div class="signupStatus">
                                <div class="ml-2 mt-2 reserved" *ngIf="currentEventSignUps[i].status === 'RESERVED'">
                                    <p-tag value="Reserved" i18n-value="@@event-sign-ups-overview.status.reserved"
                                        severity="info"></p-tag>
                                </div>
                                <div class="ml-2 mt-2 waitinglist" *ngIf="currentEventSignUps[i].status === 'QUEUED'">
                                    <p-tag value="Wating list Position {{currentEventSignUps[i].waitingPosition}}" i18n-value="@@event-sign-ups-overview.statuswaiting-list-position"
                                        severity="warning"></p-tag>

                                </div>
                            </div>
                            <div class="ml-2 mt-2 flex align-items-center attendeeEmail" *ngIf="canWrite">
                                <i class="far fa-envelope mr-1"></i> :
                                <a (click)="onMailTargetClient(currentEventSignUps[i].seat.email)" class="ml-1 cursor-pointer font-semibold">
                                    {{currentEventSignUps[i].seat.email}}
                                </a>
                            </div>
                            <div class="ml-2 mt-2 flex align-items-center attendeePhone" *ngIf="currentEventSignUps[i].seat.phoneNumber && currentEventSignUps[i].seat.phoneNumber.length && canWrite">
                                <i class="far fa-phone mr-1"></i> :
                                <a (click)="onPhoneTargetClient(currentEventSignUps[i].seat.phoneNumber)" class="ml-1 cursor-pointer font-semibold">
                                    {{currentEventSignUps[i].seat.phoneNumber}}
                                </a>
                            </div>
                            <div class="ml-2 mt-2 flex align-items-center attendeeChat" *ngIf="signUp.seat.userProfileId && coreService.isNativeApp()">
                                <i class="far fa-message-lines mr-1"></i> :
                                <a (click)="onOpenChatWithUser(signUp.seat.userProfileId)" class="ml-1 cursor-pointer font-semibold" i18n="@@event-sign-ups-overview.directchat">
                                    Direct chat
                                </a>
                            </div>
                        </div>

                    </div>
                    <div class="flex justify-content-between">
                        <div class="flex flex-column justify-content-center mt-2 md:mt-0">
                            <!-- <div class="m-2" *ngIf="signUp.seat.email && signUp.seat.email!=''">
                                <button pButton class="p-button-info p-2" icon="far fa-envelope"
                                    (click)="onMailTargetClient(currentEventSignUps[i].seat.email)"></button>
                            </div> -->
                            <ng-container *ngIf="this.context.writePermission && (signUp.status ==='CONFIRMED' || signUp.status ==='ATTENDED')">
                                <div class="eventSignUpsToggleButtons" *ngIf="event.manageAttendees">
                                    <p-button class=" p-2 confirmAttendanceButton" icon="far fa-handshake"
                                        (click)="confirmEventAttendance(signUp)" label="Presence not confirmed"
                                        i18n-label="@@event-sign-ups-overview.AttendanceNotConfirmed" severity="danger"
                                        *ngIf="signUp.status === 'CONFIRMED'" [text]="true"></p-button>
                                    <p-button class="p-2 rejectAttendanceButton" icon="far fa-handshake"
                                        (click)="rejectEventAttendance(signUp)" label="Attendance confirmed"
                                        i18n-label="@@event-sign-ups-overview.AttendanceConfirmed" severity="success"
                                        *ngIf="signUp.status === 'ATTENDED'" [text]="true"></p-button>
                                </div>
                                <div class="eventSignUpsToggleButtons" *ngIf="event.paymentDocumentation">
                                    <p-button class="p-2 confirmPaymentButton" icon="far fa-euro-sign"
                                        (click)="confirmEventPayment(signUp)" label="Payment not confirmed"
                                        i18n-label="@@event-sign-ups-overview.PaymentNotConfirmed" severity="danger"
                                        *ngIf="signUp.payed == false" [text]="true"></p-button>
                                    <p-button class="p-2 rejectPaymentButton" icon="far fa-euro-sign"
                                        (click)="rejectEventPayment(signUp)" label="Payment confirmed"
                                        i18n-label="@@event-sign-ups-overview.PaymentConfirmed" severity="success"
                                        *ngIf="signUp.payed == true" [text]="true"></p-button>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.context.writePermission && signUp.status === 'QUEUED'">
                                <div class="eventSignUpsToggleButtons">
                                    <p-button class="p-2 removeFromQueueButton" icon="far fa-check"
                                    (click)="dequeueCalendarEventRegistration(signUp)" label="Register directly"
                                    i18n-label="@@event-sign-ups-overview.register-directly"
                                    [text]="true"></p-button>
                                </div>

                            </ng-container>

                        </div>

                        <div class="mr-2 flex align-items-center ml-2 md:ml-4">
                            <p-button *ngIf="this.context.writePermission" class="p-2 deleteSignupButton" [text]="true" severity="danger" icon="far fa-trash"
                                (click)="onClickCancelSignUp(signUp)"></p-button>
                        </div>

                    </div>
                </div>

                <div class="flex mt-4 registeredBy"
                    *ngIf="currentEventSignUps[i].client && currentEventSignUps[i].client.name != currentEventSignUps[i].seat.name">
                    <div class="ml-2 mb-2 text-sm font-light">
                        <span i18n="@@event-sign-ups-overview.registered-by">Registered by</span>
                        {{currentEventSignUps[i].client.name}} (
                        <a href="mailto:{{currentEventSignUps[i].client.email}}" class="font-semibold">
                            {{currentEventSignUps[i].client.email}}
                        </a>
                        )
                    </div>
                </div>

                <div class="horizontalSeperator" *ngIf="(event.registrationForm && currentEventSignUps[i].formData) || currentEventSignUps[i].seat.comment"></div>

                <div class="flex flex-column mt-2 text-sm" *ngIf="(event.registrationForm && currentEventSignUps[i].formData) || currentEventSignUps[i].seat.comment || currentEventSignUps[i].ticket">

                    <div *ngIf="currentEventSignUps[i].seat.comment" class="flex flex-column md:flex-row attendeeComment">
                        <div  i18n="@@event-sign-ups-overview.comment" class="w-full md:w-7rem font-semibold">Comment:</div>
                        <div class="ml-0 md:ml-2 w-full md:w-10">
                            {{currentEventSignUps[i].seat.comment}}
                        </div>
                    </div>

                   <ng-container *ngIf="currentEventSignUps[i].ticket as ticket">
                        <div class="w-full md:w-5rem flex flex-column my-2">
                            <div i18n="@@event-sign-ups-overview.ticket" class="font-semibold">Ticket:</div>
                            @if(ticket.product){
                               <div >{{ticket.product.name}}</div>
                                <div>
                                   <span>{{ticket.product.price.amount / 100 | currency: ticket.product.price.currency.toUpperCase()}}</span>
                                </div>
                            }
                        </div>
                   </ng-container>

                    <ng-container *ngIf="event.registrationForm">
                        <div *ngFor="let field of event.registrationForm.fields" class="flex flex-column md:flex-row mt-2 attendeeDynamicFields">
                            <ng-container *ngIf="currentEventSignUps[i].formData && currentEventSignUps[i].formData[field.propertyName]!=null">
                                <div class="w-full md:w-7rem font-semibold">{{field.columnName}}:</div>
                                <div class="ml-0 md:ml-2 w-full md:w-10"><span *ngIf="field.datatype ==='BOOLEAN'"><i class="far fa-check" *ngIf="currentEventSignUps[i].formData[field.propertyName] ==true"></i><i class="far fa-times" *ngIf="currentEventSignUps[i].formData[field.propertyName] == false"></i></span><span *ngIf="field.datatype !=='BOOLEAN'">{{currentEventSignUps[i].formData[field.propertyName]}}</span></div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="currentEventSignUps.length == 0" class="noAtetndeesHintText">
        <p i18n="@@event-sign-ups-overview.component.text.noSignUpsForThisEvent">There are no registrations for the selected
            event.</p>
    </div>
</ng-container>

<!---- AdminSignUp Modal
<p-dialog [focusOnShow]="false" header="Title" modal="true" [(visible)]="displayAdminSignUp" *ngIf="displayAdminSignUp" [draggable]="false" [style]="{width: '90%'}">
    <lib-event-registration (closeEventRegistration)="onUpdateAfterAdminSignUp()"
    [event]="event"></lib-event-registration>

</p-dialog>-->

<!--Löschbestätigung für Reservierung-->
<p-dialog [focusOnShow]="false" header="Cancel Sign-Up" i18n-header="@@event-sign-ups-overview.component.dialog.headerCancelSignUp"
    [(visible)]="showCancelEventSignUpConfirm"  [modal]="true" [draggable]="false" [dismissableMask]="true" [focusTrap]="true" closeAriaLabel="Close" i18n-closeAriaLabel="@@event-sign-ups-overview.component.dialog.Close" 
    id="cancelSignupDialog" (onShow)="onModalShow('cancelSignupDialog')" [resizable]="false" id="cancelSignupDialog"
    class="height: 90%">
    <p i18n="@@event-sign-ups-overview.component.text.eventSignUps">Do you really want to cancel the selected registration
        for this event?</p>

    <p-button type="button" i18n="@@event-sign-ups-overview.component.button.cancelYes" label="Yes"
        icon="far fa-times" (click)="cancelUserSignUp(this.currentEventSignUpID)" icon="far fa-check"
        class="p-button-danger deleteSignUpButton"></p-button>
    <p-button type="button" i18n="@@event-sign-ups-overview.component.button.cancelNo" label="No" class="cancelButton"
        icon="far fa-times" (click)="null" icon="far fa-ban"></p-button>
</p-dialog>
